module.exports = __webpack_public_path__ + "img/tit-en.e7b9b724.svg";